import { FC } from 'react'
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { IAuthAdapter, logoutProps, WrapperProps } from '../'
import history from '../../../utils/history'
import Session from '../../../Main/Services/User/session'
import { KEY_LOCAL_STORAGE_TOKEN } from '../../Auth.constants'

export function useAuth0Adapter(): IAuthAdapter {
  const { loginWithRedirect, logout: doLogout, getAccessTokenSilently, handleRedirectCallback } = useAuth0()

  const init = async () => {
    try {
      if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        await handleRedirectCallback()
        history.push(`/orders`)
      }
    } catch (error) {
      console.error('Error during Auth0 initialization:', error)
      redirectLogin()
    }
  }

  const redirectLogin = async (email?: string) => {
    return await loginWithRedirect({
      authorizationParams: {
        login_hint: email,
        redirect_uri: `${window.location.origin}/?email=${email}&provider=auth0`
      }
    })
  }

  const getRenderLogin = () => {
    return null
  }

  const generateToken = async () => {
    try {
      const token = await getAccessTokenSilently()
      Session.set(KEY_LOCAL_STORAGE_TOKEN, token)
      return token
    } catch (_) {
      return ''
    }
  }

  const isAuthenticated = async () => {
    const token = await generateToken()
    return !!token
  }

  const logout = (props: logoutProps = {}) => {
    doLogout({ logoutParams: { ...props, returnTo: window.location.origin } })
  }

  return {
    init,
    getRenderLogin,
    redirectLogin,
    isAuthenticated,
    generateToken,
    logout
  }
}

export const GetWrapperAuth0: FC<WrapperProps> = ({ children }) => {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        useRefreshTokens: true
      }}
    >
      {children}
    </Auth0Provider>
  )
}
